import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { FormNewComponent } from "src/app/customers/news/form-new/form-new.component";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { Subject, takeUntil } from "rxjs";
import { CommonService } from "src/app/shareModule/services/common.service";
import { environment } from "src/environments/environment";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";

@Component({
    selector: 'app-profile-news',
    templateUrl: './profile-news.component.html',
    styleUrls: ['./profile-news.component.scss']
})
export class ProfileNewsComponent implements OnInit, OnDestroy {
    @Input() profile: any;
    @Input() isOwner: boolean;
    @ViewChild('formNew') formNew: FormNewComponent;
    private destroy$ = new Subject<void>();
    public banners: any = [];
    public imgUrl: string = environment.ImageUrl;
    constructor(
        private cdr: ChangeDetectorRef,
        private commonService: CommonService,
        private auth: AuthServiceService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['profile'] && changes['profile'].currentValue) {
            if (this.isOwner) {
                console.log('isOwner', this.isOwner);
            }
            // Remove setTimeout and call directly
            this.getNewsList();
        }
    }

    ngOnInit(): void {
        // Call getNewsList on component init as well
        this.getNewsList();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public getNewsList(page = 1, hashtag = "", pageSize = 12) {
        console.log('Dispatching loadNews action'); // Debug log
        this.auth.get_bottom_banner({
            isPopular: 0,
            pageSize: 15,
            createdBy: this.profile?.id
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe((response: any) => {
                console.log(response, 'BANNERS');
                this.banners = response?.body?.data;
                this.banners?.map((item: any) => {
                    if (item.slug === "null") {
                        item.slug = item.id;
                    }
                    return item;
                });
                this.cdr.detectChanges();
            })
    }

    openModalBlogForm(item: any = { text: "", category: "" }) {
        this.formNew.openModalBlogForm(item);
    }
}
